import SodRemediateFuctionSelect from './SodRemediateFuctionSelect';

export default SodRemediateFuctionSelect;
